import { createSlice } from '@reduxjs/toolkit';
import { getLoanP2PKeyByID } from './thunks';

// Initial state for Redux store:
export const initialStateLoansP2PKey = {
  loans_p2p_key: {
    loans_p2p_key: [],
    success: false,
  },
  loading: false,
};

const LoansP2PKey = createSlice({
  name: 'loans_p2p_key',
  initialState: initialStateLoansP2PKey, // Define initial state
  reducers: {
    SetLoanP2PKey: (state: any, action: any) => {
      state.drawers = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getLoanP2PKeyByID.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getLoanP2PKeyByID.fulfilled, (state, action) => {
      state.loans_p2p_key = action.payload;
      state.loading = false;
    });
  },
});

// Export actions generated by "createSlice()":
export const { SetLoanP2PKey } = LoansP2PKey.actions;

// Export reducer generated by "createSlice()":
export default LoansP2PKey.reducer;
